import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "flex items-start gap-3" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-base font-semibold text-[#16161d]" }
const _hoisted_5 = { class: "text-sm text-[#52526f]" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-1.5"
}
const _hoisted_7 = { class: "text-xs text-[#7f7f8e] truncate min-w-0" }
const _hoisted_8 = { class: "flex flex-col gap-1 py-1 text-left" }
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-semibold text-[#16161d] mb-2" }, "Escala(s)", -1)

import type { FacialBiometryDoctorItem } from '@/types/facial-biometry.types'
import { formatCrm } from '@/utils/formatters'
import { formatDoctorShortName } from '@/utils/string'
import NpsScoreAvatar from '@/components/designSystem/AvatarUser/NpsScoreAvatar.vue'
import InitialsFallback from './InitialsFallback.vue'
import ScheduleSummary from './ScheduleSummary.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorInfoCard',
  props: {
    doctor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NpsScoreAvatar, {
        "nps-score": _ctx.doctor.doctor.npsScore,
        "avatar-url": _ctx.doctor.doctor.photoUrl,
        "stroke-width": 4,
        role: "img",
        "aria-label": _ctx.doctor.doctor.name
      }, {
        default: _withCtx(() => [
          _createVNode(InitialsFallback, {
            name: _ctx.doctor.doctor.name
          }, null, 8, ["name"])
        ]),
        _: 1
      }, 8, ["nps-score", "avatar-url", "aria-label"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(formatDoctorShortName)(_ctx.doctor.doctor.name)), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(formatCrm)(_ctx.doctor.doctor.crm, _ctx.doctor.doctor.crmUf)), 1),
        (_ctx.doctor.companies?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.doctor.companies[0].name), 1),
              (_ctx.doctor.companies.length > 1)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    location: "top"
                  }, {
                    activator: _withCtx(({ props: tooltipProps }) => [
                      _createElementVNode("span", _mergeProps(tooltipProps, { class: "shrink-0 px-1.5 rounded border border-[#7f7f8e] text-[#7f7f8e] text-[10px] cursor-default" }), " +" + _toDisplayString(_ctx.doctor.companies.length - 1), 17)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctor.companies, (company) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: company.id
                          }, _toDisplayString(company.name), 1))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.doctor.schedules.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(ScheduleSummary, {
            schedules: _ctx.doctor.schedules
          }, null, 8, ["schedules"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})